import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { months } from "../../../../../../Utils/months";
import { renderDollar, renderCurrency, renderNumberKG, renderNumberKGDisabled, renderDollarDisabled, renderCurrencyDisabled } from "../../../../../../Utils/renderField/renderField";

const SkimTable = (props) => {

    const { change, skim_data, currency, comparativoData } = props;

    const data_skim = skim_data || {};

    if (!data_skim) {
        return null;
    }

    const calculateMonthlyValues = () => {
        var tempData = {};

        for (var i = 0; i < months.length; i++) {
            var month = months[i];
            var prevMonth = i > 0 ? months[i - 1] : null;

            if (!data_skim[month]) continue;

            var current = data_skim[month];
            var prodDelMes = current.produccion_del_mes || {};
            var costoVtaMes = current.costo_vta_del_mes || {};

            var getNumber = function (v) { return parseFloat(v) || 0; }

            // 1. Heredar datos del mes anterior si no es enero
            var prodTermAnterior = {};
            if (i === 0) {
                prodTermAnterior = current.prod_term_mes_anterior || {};
            } else {
                // Lógica mejorada: Verificar si el dato actual es igual al anterior (no ponderado)
                var comparativoSkimData = comparativoData && 
                    comparativoData.SKIMData && 
                    comparativoData.SKIMData.ProdTerminFinal && 
                    comparativoData.SKIMData.ProdTerminFinal[prevMonth];
                
                var comparativoSkimDataActual = comparativoData && 
                    comparativoData.SKIMData && 
                    comparativoData.SKIMData.ProdTerminFinal && 
                    comparativoData.SKIMData.ProdTerminFinal[month];
                
                // Verificar si está ponderado: si el mes actual es diferente al anterior
                var estaGrabadoElMes = comparativoSkimData && comparativoSkimDataActual &&
                    (Math.abs(getNumber(comparativoSkimData.KgSecos) - getNumber(comparativoSkimDataActual.KgSecos)) > 0.01 ||
                     Math.abs(getNumber(comparativoSkimData.CostoKgSec) - getNumber(comparativoSkimDataActual.CostoKgSec)) > 0.00001);
                
                if (comparativoSkimData && 
                    (getNumber(comparativoSkimData.KgSecos) > 0 || getNumber(comparativoSkimData.CostoKgSec) > 0) &&
                    estaGrabadoElMes) {
                    // Usar datos del comparativo si están disponibles, no son cero Y están ponderados
                    const inv_kg = getNumber(comparativoSkimData.KgSecos);
                    const inv_costo = getNumber(comparativoSkimData.CostoKgSec);
                    const inv_valor = inv_kg * inv_costo;
                    
                    prodTermAnterior = {
                        kgs_secos: inv_kg,
                        costo_kg_seco: inv_costo,
                        valor_total: inv_valor
                    };
                    
                    // Actualizar los campos del formulario con los datos del comparativo
                    change(`skim_data.${month}.prod_term_mes_anterior.kgs_secos`, inv_kg);
                    change(`skim_data.${month}.prod_term_mes_anterior.costo_kg_seco`, inv_costo);
                    change(`skim_data.${month}.prod_term_mes_anterior.valor_total`, inv_valor);
                } else {
                    // Usar datos del presupuesto (inventario final del mes anterior del mismo formulario)
 
                    const prevData = tempData[prevMonth] || data_skim[prevMonth] || {};
                    const prevProdTermFinal = prevData.prod_termin_final || {};
                    
                    const inv_kg = getNumber(prevProdTermFinal.kgs_secos);
                    const inv_costo = getNumber(prevProdTermFinal.costo_kg_seco);
                    const inv_valor = inv_kg * inv_costo;
                    
                    prodTermAnterior = {
                        kgs_secos: inv_kg,
                        costo_kg_seco: inv_costo,
                        valor_total: inv_valor
                    };
                    
                    // Actualizar los campos del formulario con los datos del presupuesto
                    change(`skim_data.${month}.prod_term_mes_anterior.kgs_secos`, inv_kg);
                    change(`skim_data.${month}.prod_term_mes_anterior.costo_kg_seco`, inv_costo);
                    change(`skim_data.${month}.prod_term_mes_anterior.valor_total`, inv_valor);
                }
            }

            var kgsSecosAnterior = getNumber(prodTermAnterior.kgs_secos);
            var costoKgAnterior = getNumber(prodTermAnterior.costo_kg_seco);
            var valorTotalAnterior = (kgsSecosAnterior * costoKgAnterior).toFixed(2);

            // 2. Producción disponible
            var kgsDisponible = (
                getNumber(prodDelMes.kgs_secos) + kgsSecosAnterior
            ).toFixed(2);

            var valorDisponible = (
                getNumber(prodDelMes.valor_total) + parseFloat(valorTotalAnterior)
            ).toFixed(2);

            var costoPromedio = kgsDisponible > 0 ? (valorDisponible / kgsDisponible) : 0;

            var costoVtaKgSeco = getNumber(costoVtaMes.kgs_secos) > 0 ? costoPromedio : 0;
            var valorVtaTotal = (getNumber(costoVtaMes.kgs_secos) * costoVtaKgSeco).toFixed(2);

            var kgsFinal = (
                getNumber(kgsDisponible) - getNumber(costoVtaMes.kgs_secos)
            ).toFixed(2);

            var valorFinal = (kgsFinal * costoPromedio).toFixed(2);

            tempData[month] = {
                prod_term_mes_anterior: {
                    kgs_secos: kgsSecosAnterior,
                    costo_kg_seco: costoKgAnterior,
                    valor_total: valorTotalAnterior
                },
                prod_term_disponible: {
                    kgs_secos: kgsDisponible,
                    costo_kg_seco: costoPromedio,
                    valor_total: valorDisponible
                },
                costo_vta_del_mes: {
                    costo_kg_seco: costoVtaKgSeco,
                    valor_total: valorVtaTotal
                },
                prod_termin_final: {
                    kgs_secos: kgsFinal,
                    costo_kg_seco: costoPromedio,
                    valor_total: valorFinal
                }
            };
        }

        for (var i = 0; i < months.length; i++) {
            var month = months[i];
            if (!tempData[month]) continue;

            var temp = tempData[month];

            // COMENTADO: No sobrescribir datos que vienen del backend para meses > enero
            // Solo aplicar cambios para enero (mes editable)
            if (i === 0) {
                change(`skim_data.${month}.prod_term_mes_anterior.kgs_secos`, temp.prod_term_mes_anterior.kgs_secos);
                change(`skim_data.${month}.prod_term_mes_anterior.costo_kg_seco`, temp.prod_term_mes_anterior.costo_kg_seco);
                change(`skim_data.${month}.prod_term_mes_anterior.valor_total`, temp.prod_term_mes_anterior.valor_total);
            }

            change(`skim_data.${month}.prod_term_disponible.kgs_secos`, temp.prod_term_disponible.kgs_secos);
            change(`skim_data.${month}.prod_term_disponible.costo_kg_seco`, temp.prod_term_disponible.costo_kg_seco);
            change(`skim_data.${month}.prod_term_disponible.valor_total`, temp.prod_term_disponible.valor_total);

            change(`skim_data.${month}.costo_vta_del_mes.costo_kg_seco`, temp.costo_vta_del_mes.costo_kg_seco);
            change(`skim_data.${month}.costo_vta_del_mes.valor_total`, temp.costo_vta_del_mes.valor_total);

            change(`skim_data.${month}.prod_termin_final.kgs_secos`, temp.prod_termin_final.kgs_secos);
            change(`skim_data.${month}.prod_termin_final.costo_kg_seco`, temp.prod_termin_final.costo_kg_seco);
            change(`skim_data.${month}.prod_termin_final.valor_total`, temp.prod_termin_final.valor_total);
        }

    };

    const executedRef = useRef(false);

    useEffect(() => {
        if (executedRef.current) return;

        const hasLatexData = months.some((month) => {
            const data = data_skim[month];
            return data && Object.keys(data).length > 0;
        });

        if (hasLatexData) {
            calculateMonthlyValues();
            executedRef.current = true;
        }
    }, [data_skim]);

    const rowDescriptionClassName = "text-left table-fixed-cell-left-0 bg-white text-nowrap tr--border-left tr--border-right";

    return (
        <div className="reports__table-bg">
            <div className="reports-table__container">
                <table className="table mb-0 text-center min-w-500">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="text-left table-fixed-cell-left-0 tr--border-top tr--border-left td--shadow-right">&nbsp;</th>
                            {months.map((_, index) => (
                                <th key={index} colSpan={3} className={`th--border ${index === 0 ? "tr--no-border-left" : ""}`}>{index + 1}</th>
                            ))}
                        </tr>
                        <tr className="tr--no-radius tr--border-top">
                            {months.map((_, index) => (
                                <React.Fragment key={index}>
                                    <th className={index > 0 ? "tr--border-left" : ""}>Kgs Secos</th>
                                    <th>Costo Kg Sec</th>
                                    <th className="tr--border-right">Valor total</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            { label: "Entradas MP a producción", key: "entradas_mp_a_produccion", style: '' },
                            { label: "(-) Skim para sólidos", key: "skim_para_solidos", style: '' },
                            { label: "(+) Cto. De Proceso", key: "cto_de_proceso", style: '' },
                            { label: "(=) Producción del mes", key: "produccion_del_mes", style: 'celda-totales ' },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={row.style + rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                        <tr className="tr--border-top">
                            <td className={rowDescriptionClassName}>(+) Prod. Term. Mes anterior</td>
                            {months.map((month, index) => {
                                const previousMonth = index > 0 ? months[index - 1] : null;
                                const monthClass = index % 2 === 0 ? "" : " month-dark";
                                return (
                                    <React.Fragment key={index}>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`skim_data.${month}.prod_term_mes_anterior.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKG}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                    isReport
                                                    onBlur={calculateMonthlyValues}
                                                />
                                            ) : (
                                                <Field
                                                    name={`skim_data.${month}.prod_term_mes_anterior.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.0 kg'
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass}>
                                            {index === 0 ? (
                                                <Field
                                                    name={`skim_data.${month}.prod_term_mes_anterior.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollar : renderCurrency}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                    onBlur={calculateMonthlyValues}
                                                />
                                            ) : (
                                                <Field
                                                    name={`skim_data.${month}.prod_term_mes_anterior.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder="$ 0.00"
                                                    decimalScale={5}
                                                />
                                            )}
                                        </td>
                                        <td className={monthClass + ' tr--border-right'}>
                                            {
                                                index === 0 ? (
                                                    <Field
                                                        name={`skim_data.${month}.prod_term_mes_anterior.valor_total`}
                                                        type="text"
                                                        component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                        className="form-control"
                                                        placeholder='$0.00'
                                                    />
                                                ) :
                                                    (
                                                        <Field
                                                            name={`skim_data.${month}.prod_term_mes_anterior.valor_total`}
                                                            type="text"
                                                            component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                            className="form-control"
                                                            placeholder='$0.00'
                                                        />
                                                    )
                                            }

                                        </td>
                                    </React.Fragment>
                                );
                            })}
                        </tr>
                        {[
                            { label: "(=) Prod. Term. Disponible", key: "prod_term_disponible", style: 'celda-totales ' },
                            { label: "(-) Costo Vta. Del Mes", key: "costo_vta_del_mes", style: '' },
                            { label: "(=) Prod. Termin. Final", key: "prod_termin_final", style: 'celda-totales ' },
                        ].map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className={row.style + rowDescriptionClassName}>{row.label}</td>
                                {months.map((month, index) => {
                                    const monthClass = index % 2 === 0 ? " month-light" : " month-dark";
                                    return (
                                        <React.Fragment key={index}>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.kgs_secos`}
                                                    type="text"
                                                    component={renderNumberKGDisabled}
                                                    className="form-control"
                                                    placeholder='0.00'
                                                />
                                            </td>
                                            <td className={row.style + monthClass}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.costo_kg_seco`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                    decimalScale={5}
                                                />
                                            </td>
                                            <td className={row.style + monthClass + ' tr--border-right'}>
                                                <Field
                                                    name={`skim_data.${month}.${row.key}.valor_total`}
                                                    type="text"
                                                    component={currency !== 'GTQ' ? renderDollarDisabled : renderCurrencyDisabled}
                                                    className="form-control"
                                                    placeholder='$0.00'
                                                />
                                            </td>
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const selector = formValueSelector("CostoVentasForm");
const mapStateToProps = (state) => ({ 
    skim_data: selector(state, 'skim_data'),
    comparativoData: state.costoDeVentas.comparativoData
});

export default connect(mapStateToProps)(SkimTable);
